import { render } from "./CategoryManage.vue?vue&type=template&id=0c04970d&scoped=true"
import script from "./CategoryManage.vue?vue&type=script&lang=js"
export * from "./CategoryManage.vue?vue&type=script&lang=js"

import "./CategoryManage.vue?vue&type=style&index=0&id=0c04970d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c04970d"]])

export default __exports__